import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const caregiverPaymentPlan = props.caregiverPaymentPlan;
  const setEditMode = props.setEditMode;

  // Format hourlyRate to two decimal places if it exists and is a number
  const formattedHourlyRate =
    caregiverPaymentPlan?.hourlyRate != null && !isNaN(Number(caregiverPaymentPlan.hourlyRate)) ?
      Number(caregiverPaymentPlan.hourlyRate).toFixed(2) :
      caregiverPaymentPlan?.hourlyRate;

  return (
    <Stack
      direction={'column'}
      sx={{
        'display': 'flex',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
      onClick={setEditMode}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '10px',
          }}
        >
          <Translate
            expression={'caregiver.CaregiverDetail.Payment.PaymentPlan.HourlyRateTitle'}
          />
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '18px',
          }}
        >
          {caregiverPaymentPlan?.hourlyRate ?
            <Translate
              expression='caregiver.CaregiverDetail.Payment.PaymentPlan.HourlyCost'
              substitute={{hourlyRate: formattedHourlyRate}}
            /> :
            <Translate
              expression='caregiver.CaregiverDetail.Payment.PaymentPlan.NoHourlyRate'
            />
          }
        </Typography>
      </Box>
    </Stack>
  );
};

Content.propTypes = {
  caregiverPaymentPlan: PropTypes.object.isRequired,
  setEditMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
